import { render } from "./humanityLibraryManage.vue?vue&type=template&id=1bb8af6a&scoped=true"
import script from "./humanityLibraryManage.vue?vue&type=script&lang=js"
export * from "./humanityLibraryManage.vue?vue&type=script&lang=js"

import "./humanityLibraryManage.vue?vue&type=style&index=0&id=1bb8af6a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb8af6a"]])

export default __exports__